export const EmployeeActionBarVI = {
    "employeeActionBar": {
        "tab": {
            "detail":"Sơ yếu lý lịch",
            "jobDetail":"Công việc",
            "contract":"Hợp đồng",
            "salary":"Lương & phụ cấp",
            "admission":"Tiếp nhận",
            "insurance":"Bảo hiểm",
            "decision":"Quyết định",
            "fileAttach": "Đính kèm",
            "asset": "Tài sản"
        },
        "item": {
            "status": "Trạng thái",
            "salary": "Lương",
            "job": "Công việc",
            "education": "Học vấn",
            "family": "Gia đình",
            "auditing": "Lịch sử hoạt động",
            "update": "Cập nhật",
            "communist": "Lịch sử đảng viên",
            "experience": "Kinh nghiệm làm việc",
            "receptionFile": "Thông tin tiếp nhận",
            "concurrently": "Kiêm nhiệm",
            "insurance": "Thông tin bảo hiểm",
            "insuranceRate": "Tỷ lệ bảo hiểm",
            "fine": "Kỷ luật nội bộ",
            "rewardWelfare": "Khen thưởng / phúc lợi",
            "account": "Tạo tài khoản",
            "back": "Quay lại"
        }
    }
}